import { Media } from "./Media";

export class Board{
    board_id:any;
    type:string;
    user_id: any;
    users_visiblity:any;
    name: any;
    description: any;
    status: any;
    context:any;
    created_date: any;
    back_image:any;
    media:Media[]=[];
    user_info:[];
    createEdit:boolean=false;
    view:boolean=false;
    card_count:any=0;
    section_count:any=0
}